import { useState } from "react";
import { CgDanger } from "react-icons/cg";
import { IoIosCloseCircleOutline } from "react-icons/io";
import "./ConsentModal.css";

const consentOptions = [
  "English Release of Medical Information Authorization",
  "French Release of Medical Information Authorization",
  "Alberta SOBP Authorization",
  "Alberta NetCare Authorization",
  "British Columbia MSP Authorization",
  "British Columbia Pharmanet Authorization",
  "Nova Scotia MSI Authorization",
  "Saskatchewan MS Authorization",
  "Ontario ODSP Authorization",
];

const ConsentModal = ({ onClose }) => {
  const [selected, setSelected] = useState([]);
  const [ohipChecked, setOhipChecked] = useState(false);

  const toggleConsent = (name) => {
    setSelected((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
    );
  };

  const handleDownload = () => {
    alert(
      `You selected ${selected.length + (ohipChecked ? 1 : 0)} consent(s).`
    );
  };

  // useEffect(() => {
  //   const handleOutsideClick = (e) => {
  //     if (modalRef.current && !modalRef.current.contains(e.target)) {
  //       onClose(); // Close modal
  //     }
  //   };
  //   document.addEventListener("mousedown", handleOutsideClick);
  //   return () => document.removeEventListener("mousedown", handleOutsideClick);
  // }, [onClose]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Print Paper Consents Forms</h2>
          <IoIosCloseCircleOutline
            className="modal-close-button"
            onClick={() => onClose()}
          />
        </div>
        <p className="red-text">
          <CgDanger className="exclaim-button" /> Print and only complete the
          Client Signature field at this time.
        </p>
        <p className="description">
          All the other fields including Date and Witness will be electronically
          completed at the time of placing the medical record request.
        </p>

        <table className="consent-table">
          <thead>
            <tr>
              <th>Select</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            {consentOptions.map((option, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="checkbox"
                    id={`consent-${index}`}
                    checked={selected.includes(option)}
                    onChange={() => toggleConsent(option)}
                  />
                </td>
                <td>
                  <label htmlFor={`consent-${index}`}>{option}</label>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="new-ohip-warning">
          <CgDanger className="exclaim-button" />
          <strong>*New* OHIP Authorization</strong> The Ministry has issued a
          new Patient Authorization that must be filled, signed, and dated by
          the patient prior to submission.
        </div>

        <div className="ohip-checkbox">
          <input
            type="checkbox"
            id="ohip"
            checked={ohipChecked}
            onChange={() => setOhipChecked(!ohipChecked)}
          />
          <label htmlFor="ohip">Ontario OHIP Authorization</label>
        </div>

        <div className="modal-footer">
          <button onClick={handleDownload}>Download Selected Consents</button>
        </div>
      </div>
    </div>
  );
};

export default ConsentModal;
